import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.css']
})
export class SetPasswordComponent {
  isSubmitted = false;
  setPasswordForm: FormGroup;
  myFormSubmit = false;
  successMessage: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiServiceService,
    public shared: SharedService
  ) {
    this.setPasswordForm = this.formBuilder.group({
      password: ['', Validators.required],
      confirm_password: ['', Validators.required],
    }, { validators: this.passwordMatchValidator });
    this.shared.isWhiteMenu = true
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password');
    const confirm_password = form.get('confirm_password');

    if (password && confirm_password && password.value !== confirm_password.value) {
      confirm_password.setErrors({ 'passwordMismatch': true });
    } else {
      confirm_password.setErrors(null);
    }
  }
  
  formControls() {
    return this.setPasswordForm.controls;
  }
  
  async onSubmit() {
    this.myFormSubmit = true;
    console.log(this.setPasswordForm.value)
    if (this.setPasswordForm.valid) {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.SET_PASSWORD,
        this.setPasswordForm.value
      );
      console.log("res", res);
      if (res && !res.error) {
        this.isSubmitted = true;
        this.successMessage = 'Your password is changed.';
      }
    }
  }
}
